import { render, staticRenderFns } from "./date-widget.vue?vue&type=template&id=e6825d22&scoped=true"
import script from "./date-widget.vue?vue&type=script&lang=js"
export * from "./date-widget.vue?vue&type=script&lang=js"
import style0 from "./date-widget.vue?vue&type=style&index=0&id=e6825d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6825d22",
  null
  
)

export default component.exports